export default {
    "sectionsBlockHeaderTemplate": "componentsCompany/cian/CardSectionsBlockHeader",
    "sectionsBlockFooterTemplate": "componentsCompany/cian/CardSectionsBlockFooter",
    "sections": {
        "library": {
            "showName": "KPI компании",
            "description": "",
            "columnsConfig": "",
            "emptyText": "Нет KPI",
            "hideOnStagesIfEmpty": [
                "assessment",
                ""
            ],
            "fromLibrary": "library",
            "fieldsAvailableForEdit": {
                "weight": {
                    "stages": [
                        "plan",
                        "correction"
                    ]
                },
                "comment.plan": {
                    "stages": [
                        "plan",
                        "correction"
                    ],
                    "skipElementEditPermissionsCheck": true
                },
                "comment.assessment": {
                    "stages": [
                        "assessment"
                    ],
                    "skipElementEditPermissionsCheck": true
                }
            }
        },
        "library_manual_fact": {
            "showName": "KPI компании декомпозированные до подразделений",
            "emptyText": "Нет KPI",
            "hideOnStagesIfEmpty": [
                "assessment",
                ""
            ],
            "fromLibrary": "library_manual_fact",
            "fieldsAvailableForEdit": {
                "weight": {
                    "stages": [
                        "plan",
                        "correction"
                    ]
                },
                "scale.fact": {
                    "stages": [
                        "assessment"
                    ]
                },
                "comment.plan": {
                    "stages": [
                        "plan",
                        "correction"
                    ],
                    "skipElementEditPermissionsCheck": true
                },
                "comment.assessment": {
                    "stages": [
                        "assessment"
                    ],
                    "skipElementEditPermissionsCheck": true
                }
            }
        },
        "manual": {
            "showName": "KPI вне дерева метрик и проектные",
            "addElementButtonText": "Создать KPI",
            "emptyText": "Нет KPI",
            "hideOnStagesIfEmpty": [
                "assessment",
                ""
            ],
            "fieldsAvailableForEdit": {
                "name": {
                    "stages": [
                        "plan",
                        "correction"
                    ]
                },
                "desc": {
                    "stages": [
                        "plan",
                        "correction"
                    ]
                },
                "weight": {
                    "stages": [
                        "plan",
                        "correction"
                    ]
                },
                "scale.template_id": {
                    "stages": [
                        "plan",
                        "correction"
                    ]
                },
                "scale.scopes": {
                    "stages": [
                        "plan",
                        "correction"
                    ]
                },
                "scale.unit_id": {
                    "stages": [
                        "plan",
                        "correction"
                    ]
                },
                "scale.plan": {
                    "stages": [
                        "plan",
                        "correction"
                    ]
                },
                "scale.fact": {
                    "stages": [
                        "assessment"
                    ]
                },
                "comment.plan": {
                    "stages": [
                        "plan",
                        "correction"
                    ],
                    "skipElementEditPermissionsCheck": true
                },
                "comment.assessment": {
                    "stages": [
                        "assessment"
                    ],
                    "skipElementEditPermissionsCheck": true
                }
            }
        },
        "multiplier": {
            "showName": "Коэффициенты",
            "addElementButtonText": "Добавить коэффициент",
            "emptyText": "Нет коэффициентов",
            "multiplyElementsBonus": true,
            "hideOnStagesIfEmpty": [
                "assessment",
                ""
            ],
            "columnsConfig": "multiplier_columns",
            "fromLibrary": "multiplier",
            "fieldsAvailableForEdit": {
                "scale.fact": {
                    "stages": [
                        "assessment"
                    ]
                },
                "comment.plan": {
                    "stages": [
                        "plan",
                        "correction"
                    ],
                    "skipElementEditPermissionsCheck": true
                },
                "comment.assessment": {
                    "stages": [
                        "assessment"
                    ],
                    "skipElementEditPermissionsCheck": true
                }
            }
        },
        "library_no_weight": {
            "showName": "KPI без веса",
            "addElementButtonText": "Создать KPI",
            "emptyText": "Нет KPI",
            "columnsConfig": "no_weight_columns",
            "hideOnStagesIfEmpty": [
                "assessment",
                ""
            ],
            "fieldsAvailableForEdit": {
                "name": {
                    "stages": [
                        "plan",
                        "correction"
                    ]
                },
                "desc": {
                    "stages": [
                        "plan",
                        "correction"
                    ]
                },
                "scale.template_id": {
                    "stages": [
                        "plan",
                        "correction"
                    ]
                },
                "scale.scopes": {
                    "stages": [
                        "plan",
                        "correction"
                    ]
                },
                "scale.unit_id": {
                    "stages": [
                        "plan",
                        "correction"
                    ]
                },
                "scale.plan": {
                    "stages": [
                        "plan",
                        "correction"
                    ]
                },
                "scale.fact": {
                    "stages": [
                        "assessment"
                    ]
                },
                "comment.plan": {
                    "stages": [
                        "plan",
                        "correction"
                    ],
                    "skipElementEditPermissionsCheck": true
                },
                "comment.assessment": {
                    "stages": [
                        "assessment"
                    ],
                    "skipElementEditPermissionsCheck": true
                }
            }
        },
        "library_admin": {
            "showName": "KPI бизнес подразделений",
            "addElementButtonText": "Создать KPI",
            "emptyText": "Нет KPI",
            "hideOnStagesIfEmpty": [
                "assessment",
                ""
            ],
            "fromLibrary": "library_admin",
            "createElementBusinessRulePermissions": [
                "elements.manage_admin_section"
            ],
            "fieldsAvailableForEdit": {
                "weight": {
                    "stages": [
                        "plan",
                        "correction"
                    ],
                    "rules": [
                        "app\\build\\cian\\rbac\\businessRules\\UserCanManageAdminSectionRule"
                    ]
                },
                "scale.template_id": {
                    "stages": [
                        "plan",
                        "correction"
                    ]
                },
                "scale.scopes": {
                    "stages": [
                        "plan",
                        "correction"
                    ]
                },
                "scale.plan": {
                    "stages": [
                        "plan",
                        "correction"
                    ]
                },
                "scale.fact": {
                    "stages": [
                        "assessment"
                    ]
                },
                "comment.plan": {
                    "stages": [
                        "plan",
                        "correction"
                    ],
                    "skipElementEditPermissionsCheck": true
                },
                "comment.assessment": {
                    "stages": [
                        "assessment"
                    ],
                    "skipElementEditPermissionsCheck": true
                }
            }
        }
    },
    "default_columns": [
        {
            "label": "Название KPI",
            "minWidth": 200,
            "template": "componentsCompany/cian/tableColumnTemplates/card/CianElementNameTableColumn.vue",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            }
        },
        {
            "label": "Вес",
            "width": 70,
            "template": "components/tableColumnTemplates/card/ElementWeightTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "Шкала",
            "width": 240,
            "template": "componentsCompany/cian/tableColumnTemplates/card/CianElementConfigurableScaleTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "Единица измерения",
            "width": 150,
            "template": "components/tableColumnTemplates/card/ElementLibraryUnitTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            }
        },
        {
            "label": "План",
            "width": 140,
            "template": "componentsCompany/cian/tableColumnTemplates/card/CianElementConfigurableScalePlanTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "Комментарий к плану",
            "width": 130,
            "template": "components/tableColumnTemplates/card/ElementCommentsTableColumn",
            "bind": {
                "scope": "scope",
                "stage": "'plan'",
                "last-comment": "scope.row.last_comment_by_stage['plan']",
                "comments-count": "scope.row.comments_count_by_stage['plan']"
            }
        },
        {
            "label": "Факт",
            "width": 240,
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true,
            "template": "components/configurableScales/tableColumnTemplates/ElementConfigurableScaleFactTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "Комментарий к факту",
            "width": 130,
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true,
            "template": "components/tableColumnTemplates/card/ElementCommentsTableColumn",
            "bind": {
                "scope": "scope",
                "stage": "'assessment'",
                "last-comment": "scope.row.last_comment_by_stage['assessment']",
                "comments-count": "scope.row.comments_count_by_stage['assessment']"
            }
        },
        {
            "label": "% премии",
            "prop": "bonus",
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true,
            "width": 100
        },
        {
            "label": "",
            "template": "components/tableColumnTemplates/card/ElementActionsTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            },
            "align": "'center'",
            "width": 50
        }
    ],
    "no_weight_columns": [
        {
            "label": "Название KPI",
            "minWidth": 200,
            "template": "componentsCompany/cian/tableColumnTemplates/card/CianElementNameTableColumn.vue",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            }
        },
        {
            "label": "Шкала",
            "width": 280,
            "template": "componentsCompany/cian/tableColumnTemplates/card/CianElementConfigurableScaleTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "Единица измерения",
            "width": 110,
            "template": "components/tableColumnTemplates/card/ElementLibraryUnitTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            }
        },
        {
            "label": "План",
            "width": 140,
            "template": "componentsCompany/cian/tableColumnTemplates/card/CianElementConfigurableScalePlanTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "Комментарий к плану",
            "width": 130,
            "template": "components/tableColumnTemplates/card/ElementCommentsTableColumn",
            "bind": {
                "scope": "scope",
                "stage": "'plan'",
                "last-comment": "scope.row.last_comment_by_stage['plan']",
                "comments-count": "scope.row.comments_count_by_stage['plan']"
            }
        },
        {
            "label": "Факт",
            "width": 240,
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true,
            "template": "components/configurableScales/tableColumnTemplates/ElementConfigurableScaleFactTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "Комментарий к факту",
            "width": 130,
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true,
            "template": "components/tableColumnTemplates/card/ElementCommentsTableColumn",
            "bind": {
                "scope": "scope",
                "stage": "'assessment'",
                "last-comment": "scope.row.last_comment_by_stage['assessment']",
                "comments-count": "scope.row.comments_count_by_stage['assessment']"
            }
        },
        {
            "label": "",
            "template": "components/tableColumnTemplates/card/ElementActionsTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            },
            "align": "'center'",
            "width": 50
        }
    ],
    "multiplier_columns": [
        {
            "label": "Название KPI",
            "minWidth": 200,
            "template": "componentsCompany/cian/tableColumnTemplates/card/CianElementNameTableColumn.vue",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            }
        },
        {
            "label": "Шкала",
            "width": 340,
            "template": "componentsCompany/cian/tableColumnTemplates/card/CianElementConfigurableScaleTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "Единица измерения",
            "width": 90,
            "template": "components/tableColumnTemplates/card/ElementLibraryUnitTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            }
        },
        {
            "label": "План",
            "width": 140,
            "template": "componentsCompany/cian/tableColumnTemplates/card/CianElementConfigurableScalePlanTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "Комментарий к плану",
            "width": 120,
            "template": "components/tableColumnTemplates/card/ElementCommentsTableColumn",
            "bind": {
                "scope": "scope",
                "stage": "'plan'",
                "last-comment": "scope.row.last_comment_by_stage['plan']",
                "comments-count": "scope.row.comments_count_by_stage['plan']"
            }
        },
        {
            "label": "Факт",
            "width": 240,
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true,
            "template": "components/configurableScales/tableColumnTemplates/ElementConfigurableScaleFactTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "Комментарий к факту",
            "width": 120,
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true,
            "template": "components/tableColumnTemplates/card/ElementCommentsTableColumn",
            "bind": {
                "scope": "scope",
                "stage": "'assessment'",
                "last-comment": "scope.row.last_comment_by_stage['assessment']",
                "comments-count": "scope.row.comments_count_by_stage['assessment']"
            }
        },
        {
            "label": "% премии",
            "prop": "bonus",
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true,
            "width": 100
        },
        {
            "label": "",
            "template": "components/tableColumnTemplates/card/ElementActionsTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            },
            "align": "'center'",
            "width": 50
        }
    ]
}